import { SVGProps } from "react"

export const UnauthorizedIcon = (props: SVGProps<SVGSVGElement>) => (
	<svg
		viewBox="0 0 303 290"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
		{...props}
	>
		<g filter="url(#filter0_d_25_1515)">
			<circle cx="145.203" cy="145" r="125" fill="#F2F7F4" />
			<circle
				cx="145.203"
				cy="145"
				r="121.614"
				stroke="white"
				strokeWidth="6.77201"
			/>
		</g>
		<mask
			id="mask0_25_1515"
			style={{ maskType: "alpha" }}
			maskUnits="userSpaceOnUse"
			x="27"
			y="27"
			width="236"
			height="236"
		>
			<circle cx="145.203" cy="145" r="117.664" fill="white" />
		</mask>
		<g mask="url(#mask0_25_1515)">
			<g clipPath="url(#clip0_25_1515)">
				<path
					d="M62.0704 262.771H223.506C226.638 262.771 229.485 260.208 229.485 256.792V137.494C229.485 134.362 226.923 131.515 223.506 131.515H141.792C139.514 131.515 137.521 130.376 136.667 128.383L131.827 118.703C130.688 116.71 128.695 115.571 126.702 115.571H59.5079C56.0913 115.571 53.5288 118.418 53.5288 121.55V254.229C53.5288 258.785 57.2302 262.771 62.0704 262.771Z"
					fill="url(#paint0_linear_25_1515)"
				/>
				<path d="M224.93 138.634H58.0842V198.71H224.93V138.634Z" fill="white" />
				<path
					d="M60.362 138.634H58.0842V198.71H60.362V138.634Z"
					fill="#E6F5E9"
				/>
				<path
					d="M224.93 138.634H58.0842V141.196H224.93V138.634Z"
					fill="#EBF5ED"
				/>
				<path
					d="M235.749 149.738V251.667C235.749 256.508 232.048 260.209 227.208 260.209H62.0704C57.2302 260.209 53.5288 256.508 53.5288 251.667V163.404C53.5288 158.564 57.2302 154.863 62.0704 154.863H145.208C147.486 154.863 149.764 154.009 151.188 152.3L159.729 143.759C161.437 142.05 163.43 141.196 165.708 141.196H227.208C232.048 141.196 235.749 145.182 235.749 149.738Z"
					fill="#E6F0E8"
				/>
				<path
					d="M235.749 152.3V254.229C235.749 259.07 232.048 262.771 227.208 262.771H62.0704C57.2302 262.771 53.5288 259.07 53.5288 254.229V165.966C53.5288 161.126 57.2302 157.425 62.0704 157.425H145.208C147.486 157.425 149.764 156.571 151.188 154.862L159.729 146.321C161.437 144.612 163.43 143.758 165.708 143.758H227.208C232.048 143.758 235.749 147.744 235.749 152.3Z"
					fill="url(#paint1_linear_25_1515)"
				/>
			</g>
			<g filter="url(#filter1_f_25_1515)">
				<path
					d="M143.261 193.523C144.059 191.96 146.294 191.96 147.092 193.523L151.044 201.268C151.356 201.88 151.943 202.306 152.621 202.414L161.209 203.78C162.942 204.056 163.633 206.18 162.392 207.423L156.248 213.575C155.762 214.061 155.538 214.75 155.645 215.429L157 224.018C157.274 225.752 155.466 227.066 153.901 226.27L146.151 222.327C145.539 222.015 144.814 222.015 144.202 222.327L136.452 226.27C134.887 227.066 133.079 225.752 133.353 224.018L134.708 215.429C134.815 214.75 134.591 214.061 134.105 213.575L127.961 207.423C126.72 206.18 127.411 204.056 129.144 203.78L137.732 202.414C138.41 202.306 138.997 201.88 139.309 201.268L143.261 193.523Z"
					fill="#BECCC1"
				/>
			</g>
			<path
				d="M143.261 193.523C144.059 191.96 146.294 191.96 147.092 193.523L151.044 201.268C151.356 201.88 151.943 202.306 152.621 202.414L161.209 203.78C162.942 204.056 163.633 206.18 162.392 207.423L156.248 213.575C155.762 214.061 155.538 214.75 155.645 215.429L157 224.018C157.274 225.752 155.466 227.066 153.901 226.27L146.151 222.327C145.539 222.015 144.814 222.015 144.202 222.327L136.452 226.27C134.887 227.066 133.079 225.752 133.353 224.018L134.708 215.429C134.815 214.75 134.591 214.061 134.105 213.575L127.961 207.423C126.72 206.18 127.411 204.056 129.144 203.78L137.732 202.414C138.41 202.306 138.997 201.88 139.309 201.268L143.261 193.523Z"
				fill="#FEFEFE"
			/>
		</g>
		<g filter="url(#filter2_f_25_1515)">
			<circle
				cx="252.427"
				cy="82.359"
				r="27.3702"
				fill="#BECCC1"
				fillOpacity="0.7"
			/>
		</g>
		<circle
			cx="246.219"
			cy="76.1515"
			r="27.3702"
			fill="url(#paint2_linear_25_1515)"
		/>
		<path
			d="M253.932 69.8492L253.368 69.8492L253.932 69.8492C253.932 69.4751 253.783 69.1162 253.519 68.8516C253.254 68.587 252.895 68.4384 252.521 68.4384C252.147 68.4384 251.788 68.587 251.523 68.8516L245.937 74.4382L240.35 68.8516C240.086 68.587 239.727 68.4384 239.353 68.4384C238.978 68.4384 238.62 68.587 238.355 68.8516C238.09 69.1162 237.942 69.4751 237.942 69.8492L238.505 69.8492L237.942 69.8492C237.942 70.2234 238.09 70.5823 238.355 70.8468L243.942 76.4335L238.355 82.0201C238.09 82.2847 237.942 82.6435 237.942 83.0177C237.942 83.3919 238.09 83.7507 238.355 84.0153C238.62 84.2799 238.978 84.4285 239.353 84.4285C239.727 84.4285 240.086 84.2799 240.35 84.0153L245.937 78.4287L251.523 84.0153C251.788 84.2799 252.147 84.4285 252.521 84.4285C252.895 84.4285 253.254 84.2799 253.519 84.0153C253.783 83.7507 253.932 83.3919 253.932 83.0177C253.932 82.6435 253.783 82.2847 253.519 82.0201L247.932 76.4335L253.519 70.8468C253.783 70.5823 253.932 70.2234 253.932 69.8492Z"
			fill="white"
			stroke="white"
			strokeWidth="1.12867"
		/>
		<defs>
			<filter
				id="filter0_d_25_1515"
				x="0.203125"
				y="0"
				width="290"
				height="290"
				filterUnits="userSpaceOnUse"
				colorInterpolationFilters="sRGB"
			>
				<feFlood floodOpacity="0" result="BackgroundImageFix" />
				<feColorMatrix
					in="SourceAlpha"
					type="matrix"
					values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
					result="hardAlpha"
				/>
				<feOffset />
				<feGaussianBlur stdDeviation="10" />
				<feComposite in2="hardAlpha" operator="out" />
				<feColorMatrix
					type="matrix"
					values="0 0 0 0 0.901961 0 0 0 0 0.941176 0 0 0 0 0.909804 0 0 0 0.6 0"
				/>
				<feBlend
					mode="normal"
					in2="BackgroundImageFix"
					result="effect1_dropShadow_25_1515"
				/>
				<feBlend
					mode="normal"
					in="SourceGraphic"
					in2="effect1_dropShadow_25_1515"
					result="shape"
				/>
			</filter>
			<filter
				id="filter1_f_25_1515"
				x="116.579"
				y="181.6"
				width="57.1943"
				height="55.6582"
				filterUnits="userSpaceOnUse"
				colorInterpolationFilters="sRGB"
			>
				<feFlood floodOpacity="0" result="BackgroundImageFix" />
				<feBlend
					mode="normal"
					in="SourceGraphic"
					in2="BackgroundImageFix"
					result="shape"
				/>
				<feGaussianBlur
					stdDeviation="5.37523"
					result="effect1_foregroundBlur_25_1515"
				/>
			</filter>
			<filter
				id="filter2_f_25_1515"
				x="202.483"
				y="32.4154"
				width="99.8872"
				height="99.887"
				filterUnits="userSpaceOnUse"
				colorInterpolationFilters="sRGB"
			>
				<feFlood floodOpacity="0" result="BackgroundImageFix" />
				<feBlend
					mode="normal"
					in="SourceGraphic"
					in2="BackgroundImageFix"
					result="shape"
				/>
				<feGaussianBlur
					stdDeviation="11.2867"
					result="effect1_foregroundBlur_25_1515"
				/>
			</filter>
			<linearGradient
				id="paint0_linear_25_1515"
				x1="141.507"
				y1="115.571"
				x2="141.507"
				y2="174.451"
				gradientUnits="userSpaceOnUse"
			>
				<stop stopColor="#E6F0E8" />
				<stop offset="1" stopColor="#BECCC1" />
			</linearGradient>
			<linearGradient
				id="paint1_linear_25_1515"
				x1="144.639"
				y1="143.758"
				x2="144.639"
				y2="262.771"
				gradientUnits="userSpaceOnUse"
			>
				<stop stopColor="#BECCC1" />
				<stop offset="1" stopColor="#E6F0E8" />
			</linearGradient>
			<linearGradient
				id="paint2_linear_25_1515"
				x1="246.219"
				y1="48.7812"
				x2="246.219"
				y2="103.522"
				gradientUnits="userSpaceOnUse"
			>
				<stop stopColor="#E6F0E8" />
				<stop offset="1" stopColor="#BECCC1" />
			</linearGradient>
			<clipPath id="clip0_25_1515">
				<rect
					width="182.22"
					height="182.22"
					fill="white"
					transform="translate(53.5288 96.7798)"
				/>
			</clipPath>
		</defs>
	</svg>
)
